// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as YdelserRouteImport } from './routes/ydelser'
import { Route as VarmepumperRouteImport } from './routes/varmepumper'
import { Route as TilbudRouteImport } from './routes/tilbud'
import { Route as TekniqGarantiRouteImport } from './routes/tekniq-garanti'
import { Route as SitemapRouteImport } from './routes/sitemap'
import { Route as PriserPrivatRouteImport } from './routes/priser-privat'
import { Route as PriserErhvervRouteImport } from './routes/priser-erhverv'
import { Route as OmOsRouteImport } from './routes/om-os'
import { Route as LadestandereRouteImport } from './routes/ladestandere'
import { Route as KontaktRouteImport } from './routes/kontakt'
import { Route as GroenEnergiRouteImport } from './routes/groen-energi'
import { Route as FejlfindingRouteImport } from './routes/fejlfinding'
import { Route as EnergioptimeringRouteImport } from './routes/energioptimering'
import { Route as ElektrikerVirumRouteImport } from './routes/elektriker-virum'
import { Route as ElektrikerVesterbroRouteImport } from './routes/elektriker-vesterbro'
import { Route as ElektrikerVedbaekRouteImport } from './routes/elektriker-vedbaek'
import { Route as ElektrikerVanloeseRouteImport } from './routes/elektriker-vanloese'
import { Route as ElektrikerValbyRouteImport } from './routes/elektriker-valby'
import { Route as ElektrikerSydhavnRouteImport } from './routes/elektriker-sydhavn'
import { Route as ElektrikerSoborgRouteImport } from './routes/elektriker-soborg'
import { Route as ElektrikerSkovshovedRouteImport } from './routes/elektriker-skovshoved'
import { Route as ElektrikerSkovlundeRouteImport } from './routes/elektriker-skovlunde'
import { Route as ElektrikerRoedovreRouteImport } from './routes/elektriker-roedovre'
import { Route as ElektrikerOesterbroRouteImport } from './routes/elektriker-oesterbro'
import { Route as ElektrikerNorrebroRouteImport } from './routes/elektriker-norrebro'
import { Route as ElektrikerNordvestRouteImport } from './routes/elektriker-nordvest'
import { Route as ElektrikerNordsjaellandRouteImport } from './routes/elektriker-nordsjaelland'
import { Route as ElektrikerNordhavnRouteImport } from './routes/elektriker-nordhavn'
import { Route as ElektrikerLyngbyRouteImport } from './routes/elektriker-lyngby'
import { Route as ElektrikerKoebenhavnRouteImport } from './routes/elektriker-koebenhavn'
import { Route as ElektrikerKlampenborgRouteImport } from './routes/elektriker-klampenborg'
import { Route as ElektrikerKastrupRouteImport } from './routes/elektriker-kastrup'
import { Route as ElektrikerIndreByRouteImport } from './routes/elektriker-indre-by'
import { Route as ElektrikerHvidovreRouteImport } from './routes/elektriker-hvidovre'
import { Route as ElektrikerHolteRouteImport } from './routes/elektriker-holte'
import { Route as ElektrikerHoersholmRouteImport } from './routes/elektriker-hoersholm'
import { Route as ElektrikerHerlevRouteImport } from './routes/elektriker-herlev'
import { Route as ElektrikerHellerupRouteImport } from './routes/elektriker-hellerup'
import { Route as ElektrikerGreveRouteImport } from './routes/elektriker-greve'
import { Route as ElektrikerGladsaxeRouteImport } from './routes/elektriker-gladsaxe'
import { Route as ElektrikerGentofteRouteImport } from './routes/elektriker-gentofte'
import { Route as ElektrikerFrederiksbergRouteImport } from './routes/elektriker-frederiksberg'
import { Route as ElektrikerDragoerRouteImport } from './routes/elektriker-dragoer'
import { Route as ElektrikerChristianshavnRouteImport } from './routes/elektriker-christianshavn'
import { Route as ElektrikerCharlottenlundRouteImport } from './routes/elektriker-charlottenlund'
import { Route as ElektrikerBroenshoejRouteImport } from './routes/elektriker-broenshoej'
import { Route as ElektrikerBirkeroedRouteImport } from './routes/elektriker-birkeroed'
import { Route as ElektrikerBallerupRouteImport } from './routes/elektriker-ballerup'
import { Route as ElektrikerBagsvaerdRouteImport } from './routes/elektriker-bagsvaerd'
import { Route as ElektrikerAmagerRouteImport } from './routes/elektriker-amager'
import { Route as CareersRouteImport } from './routes/careers'
import { Route as ByerRouteImport } from './routes/byer'
import { Route as BaeredygtighedRouteImport } from './routes/baeredygtighed'
import { Route as SplatRouteImport } from './routes/$'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogPrisenPaaElektricitetRouteImport } from './routes/blog.prisen-paa-elektricitet'
import { Route as BlogOliefyrTilVarmepumpeRouteImport } from './routes/blog.oliefyr-til-varmepumpe'
import { Route as BlogHfiVsHpfiRelaeRouteImport } from './routes/blog.hfi-vs-hpfi-relae'
import { Route as BlogFjernsynStroemforbrugRouteImport } from './routes/blog.fjernsyn-stroemforbrug'
import { Route as BlogErStroemFarligtRouteImport } from './routes/blog.er-stroem-farligt'
import { Route as BlogErLedEnergivenligtRouteImport } from './routes/blog.er-led-energivenligt'

const YdelserRoute = YdelserRouteImport.update({
            id: '/ydelser',path: '/ydelser',getParentRoute: () => rootRouteImport
          })
const VarmepumperRoute = VarmepumperRouteImport.update({
            id: '/varmepumper',path: '/varmepumper',getParentRoute: () => rootRouteImport
          })
const TilbudRoute = TilbudRouteImport.update({
            id: '/tilbud',path: '/tilbud',getParentRoute: () => rootRouteImport
          })
const TekniqGarantiRoute = TekniqGarantiRouteImport.update({
            id: '/tekniq-garanti',path: '/tekniq-garanti',getParentRoute: () => rootRouteImport
          })
const SitemapRoute = SitemapRouteImport.update({
            id: '/sitemap',path: '/sitemap',getParentRoute: () => rootRouteImport
          })
const PriserPrivatRoute = PriserPrivatRouteImport.update({
            id: '/priser-privat',path: '/priser-privat',getParentRoute: () => rootRouteImport
          })
const PriserErhvervRoute = PriserErhvervRouteImport.update({
            id: '/priser-erhverv',path: '/priser-erhverv',getParentRoute: () => rootRouteImport
          })
const OmOsRoute = OmOsRouteImport.update({
            id: '/om-os',path: '/om-os',getParentRoute: () => rootRouteImport
          })
const LadestandereRoute = LadestandereRouteImport.update({
            id: '/ladestandere',path: '/ladestandere',getParentRoute: () => rootRouteImport
          })
const KontaktRoute = KontaktRouteImport.update({
            id: '/kontakt',path: '/kontakt',getParentRoute: () => rootRouteImport
          })
const GroenEnergiRoute = GroenEnergiRouteImport.update({
            id: '/groen-energi',path: '/groen-energi',getParentRoute: () => rootRouteImport
          })
const FejlfindingRoute = FejlfindingRouteImport.update({
            id: '/fejlfinding',path: '/fejlfinding',getParentRoute: () => rootRouteImport
          })
const EnergioptimeringRoute = EnergioptimeringRouteImport.update({
            id: '/energioptimering',path: '/energioptimering',getParentRoute: () => rootRouteImport
          })
const ElektrikerVirumRoute = ElektrikerVirumRouteImport.update({
            id: '/elektriker-virum',path: '/elektriker-virum',getParentRoute: () => rootRouteImport
          })
const ElektrikerVesterbroRoute = ElektrikerVesterbroRouteImport.update({
            id: '/elektriker-vesterbro',path: '/elektriker-vesterbro',getParentRoute: () => rootRouteImport
          })
const ElektrikerVedbaekRoute = ElektrikerVedbaekRouteImport.update({
            id: '/elektriker-vedbaek',path: '/elektriker-vedbaek',getParentRoute: () => rootRouteImport
          })
const ElektrikerVanloeseRoute = ElektrikerVanloeseRouteImport.update({
            id: '/elektriker-vanloese',path: '/elektriker-vanloese',getParentRoute: () => rootRouteImport
          })
const ElektrikerValbyRoute = ElektrikerValbyRouteImport.update({
            id: '/elektriker-valby',path: '/elektriker-valby',getParentRoute: () => rootRouteImport
          })
const ElektrikerSydhavnRoute = ElektrikerSydhavnRouteImport.update({
            id: '/elektriker-sydhavn',path: '/elektriker-sydhavn',getParentRoute: () => rootRouteImport
          })
const ElektrikerSoborgRoute = ElektrikerSoborgRouteImport.update({
            id: '/elektriker-soborg',path: '/elektriker-soborg',getParentRoute: () => rootRouteImport
          })
const ElektrikerSkovshovedRoute = ElektrikerSkovshovedRouteImport.update({
            id: '/elektriker-skovshoved',path: '/elektriker-skovshoved',getParentRoute: () => rootRouteImport
          })
const ElektrikerSkovlundeRoute = ElektrikerSkovlundeRouteImport.update({
            id: '/elektriker-skovlunde',path: '/elektriker-skovlunde',getParentRoute: () => rootRouteImport
          })
const ElektrikerRoedovreRoute = ElektrikerRoedovreRouteImport.update({
            id: '/elektriker-roedovre',path: '/elektriker-roedovre',getParentRoute: () => rootRouteImport
          })
const ElektrikerOesterbroRoute = ElektrikerOesterbroRouteImport.update({
            id: '/elektriker-oesterbro',path: '/elektriker-oesterbro',getParentRoute: () => rootRouteImport
          })
const ElektrikerNorrebroRoute = ElektrikerNorrebroRouteImport.update({
            id: '/elektriker-norrebro',path: '/elektriker-norrebro',getParentRoute: () => rootRouteImport
          })
const ElektrikerNordvestRoute = ElektrikerNordvestRouteImport.update({
            id: '/elektriker-nordvest',path: '/elektriker-nordvest',getParentRoute: () => rootRouteImport
          })
const ElektrikerNordsjaellandRoute = ElektrikerNordsjaellandRouteImport.update({
            id: '/elektriker-nordsjaelland',path: '/elektriker-nordsjaelland',getParentRoute: () => rootRouteImport
          })
const ElektrikerNordhavnRoute = ElektrikerNordhavnRouteImport.update({
            id: '/elektriker-nordhavn',path: '/elektriker-nordhavn',getParentRoute: () => rootRouteImport
          })
const ElektrikerLyngbyRoute = ElektrikerLyngbyRouteImport.update({
            id: '/elektriker-lyngby',path: '/elektriker-lyngby',getParentRoute: () => rootRouteImport
          })
const ElektrikerKoebenhavnRoute = ElektrikerKoebenhavnRouteImport.update({
            id: '/elektriker-koebenhavn',path: '/elektriker-koebenhavn',getParentRoute: () => rootRouteImport
          })
const ElektrikerKlampenborgRoute = ElektrikerKlampenborgRouteImport.update({
            id: '/elektriker-klampenborg',path: '/elektriker-klampenborg',getParentRoute: () => rootRouteImport
          })
const ElektrikerKastrupRoute = ElektrikerKastrupRouteImport.update({
            id: '/elektriker-kastrup',path: '/elektriker-kastrup',getParentRoute: () => rootRouteImport
          })
const ElektrikerIndreByRoute = ElektrikerIndreByRouteImport.update({
            id: '/elektriker-indre-by',path: '/elektriker-indre-by',getParentRoute: () => rootRouteImport
          })
const ElektrikerHvidovreRoute = ElektrikerHvidovreRouteImport.update({
            id: '/elektriker-hvidovre',path: '/elektriker-hvidovre',getParentRoute: () => rootRouteImport
          })
const ElektrikerHolteRoute = ElektrikerHolteRouteImport.update({
            id: '/elektriker-holte',path: '/elektriker-holte',getParentRoute: () => rootRouteImport
          })
const ElektrikerHoersholmRoute = ElektrikerHoersholmRouteImport.update({
            id: '/elektriker-hoersholm',path: '/elektriker-hoersholm',getParentRoute: () => rootRouteImport
          })
const ElektrikerHerlevRoute = ElektrikerHerlevRouteImport.update({
            id: '/elektriker-herlev',path: '/elektriker-herlev',getParentRoute: () => rootRouteImport
          })
const ElektrikerHellerupRoute = ElektrikerHellerupRouteImport.update({
            id: '/elektriker-hellerup',path: '/elektriker-hellerup',getParentRoute: () => rootRouteImport
          })
const ElektrikerGreveRoute = ElektrikerGreveRouteImport.update({
            id: '/elektriker-greve',path: '/elektriker-greve',getParentRoute: () => rootRouteImport
          })
const ElektrikerGladsaxeRoute = ElektrikerGladsaxeRouteImport.update({
            id: '/elektriker-gladsaxe',path: '/elektriker-gladsaxe',getParentRoute: () => rootRouteImport
          })
const ElektrikerGentofteRoute = ElektrikerGentofteRouteImport.update({
            id: '/elektriker-gentofte',path: '/elektriker-gentofte',getParentRoute: () => rootRouteImport
          })
const ElektrikerFrederiksbergRoute = ElektrikerFrederiksbergRouteImport.update({
            id: '/elektriker-frederiksberg',path: '/elektriker-frederiksberg',getParentRoute: () => rootRouteImport
          })
const ElektrikerDragoerRoute = ElektrikerDragoerRouteImport.update({
            id: '/elektriker-dragoer',path: '/elektriker-dragoer',getParentRoute: () => rootRouteImport
          })
const ElektrikerChristianshavnRoute = ElektrikerChristianshavnRouteImport.update({
            id: '/elektriker-christianshavn',path: '/elektriker-christianshavn',getParentRoute: () => rootRouteImport
          })
const ElektrikerCharlottenlundRoute = ElektrikerCharlottenlundRouteImport.update({
            id: '/elektriker-charlottenlund',path: '/elektriker-charlottenlund',getParentRoute: () => rootRouteImport
          })
const ElektrikerBroenshoejRoute = ElektrikerBroenshoejRouteImport.update({
            id: '/elektriker-broenshoej',path: '/elektriker-broenshoej',getParentRoute: () => rootRouteImport
          })
const ElektrikerBirkeroedRoute = ElektrikerBirkeroedRouteImport.update({
            id: '/elektriker-birkeroed',path: '/elektriker-birkeroed',getParentRoute: () => rootRouteImport
          })
const ElektrikerBallerupRoute = ElektrikerBallerupRouteImport.update({
            id: '/elektriker-ballerup',path: '/elektriker-ballerup',getParentRoute: () => rootRouteImport
          })
const ElektrikerBagsvaerdRoute = ElektrikerBagsvaerdRouteImport.update({
            id: '/elektriker-bagsvaerd',path: '/elektriker-bagsvaerd',getParentRoute: () => rootRouteImport
          })
const ElektrikerAmagerRoute = ElektrikerAmagerRouteImport.update({
            id: '/elektriker-amager',path: '/elektriker-amager',getParentRoute: () => rootRouteImport
          })
const CareersRoute = CareersRouteImport.update({
            id: '/careers',path: '/careers',getParentRoute: () => rootRouteImport
          })
const ByerRoute = ByerRouteImport.update({
            id: '/byer',path: '/byer',getParentRoute: () => rootRouteImport
          })
const BaeredygtighedRoute = BaeredygtighedRouteImport.update({
            id: '/baeredygtighed',path: '/baeredygtighed',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogPrisenPaaElektricitetRoute = BlogPrisenPaaElektricitetRouteImport.update({
            id: '/blog/prisen-paa-elektricitet',path: '/blog/prisen-paa-elektricitet',getParentRoute: () => rootRouteImport
          })
const BlogOliefyrTilVarmepumpeRoute = BlogOliefyrTilVarmepumpeRouteImport.update({
            id: '/blog/oliefyr-til-varmepumpe',path: '/blog/oliefyr-til-varmepumpe',getParentRoute: () => rootRouteImport
          })
const BlogHfiVsHpfiRelaeRoute = BlogHfiVsHpfiRelaeRouteImport.update({
            id: '/blog/hfi-vs-hpfi-relae',path: '/blog/hfi-vs-hpfi-relae',getParentRoute: () => rootRouteImport
          })
const BlogFjernsynStroemforbrugRoute = BlogFjernsynStroemforbrugRouteImport.update({
            id: '/blog/fjernsyn-stroemforbrug',path: '/blog/fjernsyn-stroemforbrug',getParentRoute: () => rootRouteImport
          })
const BlogErStroemFarligtRoute = BlogErStroemFarligtRouteImport.update({
            id: '/blog/er-stroem-farligt',path: '/blog/er-stroem-farligt',getParentRoute: () => rootRouteImport
          })
const BlogErLedEnergivenligtRoute = BlogErLedEnergivenligtRouteImport.update({
            id: '/blog/er-led-energivenligt',path: '/blog/er-led-energivenligt',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,BaeredygtighedRoute: BaeredygtighedRoute,ByerRoute: ByerRoute,CareersRoute: CareersRoute,ElektrikerAmagerRoute: ElektrikerAmagerRoute,ElektrikerBagsvaerdRoute: ElektrikerBagsvaerdRoute,ElektrikerBallerupRoute: ElektrikerBallerupRoute,ElektrikerBirkeroedRoute: ElektrikerBirkeroedRoute,ElektrikerBroenshoejRoute: ElektrikerBroenshoejRoute,ElektrikerCharlottenlundRoute: ElektrikerCharlottenlundRoute,ElektrikerChristianshavnRoute: ElektrikerChristianshavnRoute,ElektrikerDragoerRoute: ElektrikerDragoerRoute,ElektrikerFrederiksbergRoute: ElektrikerFrederiksbergRoute,ElektrikerGentofteRoute: ElektrikerGentofteRoute,ElektrikerGladsaxeRoute: ElektrikerGladsaxeRoute,ElektrikerGreveRoute: ElektrikerGreveRoute,ElektrikerHellerupRoute: ElektrikerHellerupRoute,ElektrikerHerlevRoute: ElektrikerHerlevRoute,ElektrikerHoersholmRoute: ElektrikerHoersholmRoute,ElektrikerHolteRoute: ElektrikerHolteRoute,ElektrikerHvidovreRoute: ElektrikerHvidovreRoute,ElektrikerIndreByRoute: ElektrikerIndreByRoute,ElektrikerKastrupRoute: ElektrikerKastrupRoute,ElektrikerKlampenborgRoute: ElektrikerKlampenborgRoute,ElektrikerKoebenhavnRoute: ElektrikerKoebenhavnRoute,ElektrikerLyngbyRoute: ElektrikerLyngbyRoute,ElektrikerNordhavnRoute: ElektrikerNordhavnRoute,ElektrikerNordsjaellandRoute: ElektrikerNordsjaellandRoute,ElektrikerNordvestRoute: ElektrikerNordvestRoute,ElektrikerNorrebroRoute: ElektrikerNorrebroRoute,ElektrikerOesterbroRoute: ElektrikerOesterbroRoute,ElektrikerRoedovreRoute: ElektrikerRoedovreRoute,ElektrikerSkovlundeRoute: ElektrikerSkovlundeRoute,ElektrikerSkovshovedRoute: ElektrikerSkovshovedRoute,ElektrikerSoborgRoute: ElektrikerSoborgRoute,ElektrikerSydhavnRoute: ElektrikerSydhavnRoute,ElektrikerValbyRoute: ElektrikerValbyRoute,ElektrikerVanloeseRoute: ElektrikerVanloeseRoute,ElektrikerVedbaekRoute: ElektrikerVedbaekRoute,ElektrikerVesterbroRoute: ElektrikerVesterbroRoute,ElektrikerVirumRoute: ElektrikerVirumRoute,EnergioptimeringRoute: EnergioptimeringRoute,FejlfindingRoute: FejlfindingRoute,GroenEnergiRoute: GroenEnergiRoute,KontaktRoute: KontaktRoute,LadestandereRoute: LadestandereRoute,OmOsRoute: OmOsRoute,PriserErhvervRoute: PriserErhvervRoute,PriserPrivatRoute: PriserPrivatRoute,SitemapRoute: SitemapRoute,TekniqGarantiRoute: TekniqGarantiRoute,TilbudRoute: TilbudRoute,VarmepumperRoute: VarmepumperRoute,YdelserRoute: YdelserRoute,BlogErLedEnergivenligtRoute: BlogErLedEnergivenligtRoute,BlogErStroemFarligtRoute: BlogErStroemFarligtRoute,BlogFjernsynStroemforbrugRoute: BlogFjernsynStroemforbrugRoute,BlogHfiVsHpfiRelaeRoute: BlogHfiVsHpfiRelaeRoute,BlogOliefyrTilVarmepumpeRoute: BlogOliefyrTilVarmepumpeRoute,BlogPrisenPaaElektricitetRoute: BlogPrisenPaaElektricitetRoute,BlogIndexRoute: BlogIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)